const defaultIfUndefined = <T, >(value: T | undefined, defaultValue: T): T => {
    if (value === undefined) return defaultValue;

    return value;
};

export default defaultIfUndefined;
